import React from "react";
import { useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import { useWishlist } from "@/lib/wishlist";

export default function WishlistButton({ id, className = "", size = 18 }) {
  const { has, toggle } = useWishlist();
  const nav = useNavigate();
  const active = has(id);
  const onClick = async (e) => {
    e.preventDefault(); e.stopPropagation();
    const r = await toggle(id);
    if (r?.needAuth) { toast("Sign in to save favourites"); nav("/auth"); return; }
    toast(active ? "Removed from wishlist" : "Added to wishlist");
  };
  return (
    <button onClick={onClick} data-testid={`wishlist-toggle-${id}`} aria-label="Wishlist"
      className={`grid place-items-center hover:scale-110 transition-transform drop-shadow-[0_1px_2px_rgba(0,0,0,0.35)] ${className}`}
      style={{ width: size + 8, height: size + 8 }}>
      <Heart size={size} className={active ? "fill-red-500 text-red-500" : "fill-white/30 text-white"} />
    </button>
  );
}
